/** @file Icons that are custom-made specifically for our own needs. */
// eslint-disable-next-line no-restricted-imports
import { Glasses, Rocket } from 'lucide';
// Reusable components within custom icons
const outlineRect = ['rect', { width: 18, height: 18, x: 3, y: 3, rx: 2 }];
const outlineCircle = ['circle', { cx: 12, cy: 12, r: 10 }];
const slash = ['line', { x1: 3.47016, y1: 2.05594, x2: 21.9441, y2: 20.5298 }];
/** A CodeGrade custom icon. */
export const UnpublishSnapshot = Object.freeze([slash, ...Rocket]);
/** @inheritdoc */
export const StudentViewOff = Object.freeze([slash, ...Glasses]);
/** @inheritdoc */
export const StepIOTest = Object.freeze([
    outlineRect,
    ['line', { x1: 7.33, x2: 7.33, y1: 8.5, y2: 15.33 }],
    ['circle', { cx: 14, cy: 12, r: 3.165 }],
]);
/** @inheritdoc */
export const CLang = Object.freeze([
    outlineRect,
    [
        'path',
        {
            d: 'M15.0433 15.0431C13.3625 16.7239 10.6375 16.7239 8.95676 15.0431C7.27601 13.3624 7.27601 10.6374 8.95676 8.9566C10.6375 7.27585 13.3625 7.27585 15.0433 8.9566',
        },
    ],
]);
/** @inheritdoc */
export const HTML5 = Object.freeze([
    [
        'path',
        {
            stroke: 'transparent',
            fill: 'currentColor',
            d: 'M5.0813 0H6.15942V1.06875H7.15317V0H8.2313V3.23438H7.15317V2.15625H6.1688V3.23438H5.0813M9.6563 1.07812H8.70474V0H11.6907V1.07812H10.7344V3.23438H9.6563M12.1641 0H13.2938L13.9875 1.13906L14.6813 0H15.811V3.23438H14.7329V1.63125L13.9782 2.79375L13.2235 1.63125V3.23438H12.1641M16.3454 0H17.4235V2.16563H18.9516V3.23438H16.3454',
        },
    ],
    [
        'path',
        {
            stroke: 'transparent',
            fill: 'currentColor',
            fillRule: 'evenodd',
            d: 'M20.5219 4.70813L19.0161 22.0763L12.0829 24.0838L4.93964 22.0763L3.51562 4.67316L20.5219 4.70813ZM7.18062 14.7345H14.6158L14.3242 17.5125L11.9431 18.1543L9.52693 17.454L9.39857 15.7966H7.26233L7.5542 19.1815L11.9429 20.4071L16.3666 19.1815L16.9618 12.5752H9.15335L8.93156 10.3458H17.1604L17.3587 8.22142H6.58539L7.18062 14.7345Z',
        },
    ],
]);
/** @inheritdoc */
export const JUnit5 = Object.freeze([
    ['circle', { cx: 13, cy: 13, r: 10 }],
    [
        'path',
        {
            d: 'M15.7673 8.07422H10.8744L10.3449 12.4218C12.7193 11.1544 15.8476 11.2346 15.8476 14.6517C15.8476 17.9982 12.2986 18.9155 10.1524 16.7693',
        },
    ],
]);
/** @inheritdoc */
export const FilePDF = Object.freeze([
    [
        'path',
        {
            d: 'M4 20.3557C4 20.8861 4.21071 21.3949 4.58579 21.7699C4.96086 22.145 5.46957 22.3557 6 22.3557H18C18.5304 22.3557 19.0391 22.145 19.4142 21.7699C19.7893 21.3949 20 20.8861 20 20.3557M4 9.0625V4.35571C4 3.82528 4.21071 3.31657 4.58579 2.9415C4.96086 2.56643 5.46957 2.35571 6 2.35571H15L20 7.35571V9.0625',
        },
    ],
    [
        'path',
        {
            d: 'M14 2.35571V6.35571C14 6.88615 14.2107 7.39485 14.5858 7.76993C14.9609 8.145 15.4696 8.35571 16 8.35571H20',
        },
    ],
    [
        'path',
        {
            d: 'M3.68799 17.8707V15.0509M3.68799 15.0509V11.7556C3.68799 11.7515 3.69124 11.7483 3.69526 11.7483H5.64411C6.5561 11.7483 7.2954 12.4876 7.2954 13.3996V13.3996C7.2954 14.3116 6.5561 15.0509 5.64411 15.0509H3.68799Z',
        },
    ],
    [
        'path',
        {
            d: 'M17.4288 17.8707V15.0509M20.3125 11.7483H17.6154C17.5124 11.7483 17.4288 11.8318 17.4288 11.9349V15.0509M20.3125 15.0509H17.4288',
        },
    ],
    [
        'path',
        {
            d: 'M11.3092 11.7483H10.54C10.4369 11.7483 10.3534 11.8318 10.3534 11.9349V17.6841C10.3534 17.7872 10.4369 17.8707 10.54 17.8707H11.3092C12.9998 17.8707 14.3704 16.5001 14.3704 14.8095C14.3704 13.1188 12.9998 11.7483 11.3092 11.7483Z',
        },
    ],
]);
/** @inheritdoc */
export const StepSubstringMatch = Object.freeze([
    outlineRect,
    ['path', { d: 'M15.2305 7.22559L8.51746 10.2603L15.2305 13.3318' }],
    ['path', { d: 'M8.45892 16.4763L15.2889 16.4763' }],
]);
/** @inheritdoc */
export const Markdown = Object.freeze([
    [
        'path',
        {
            d: 'M22.2675 5H1.7325C0.77625 5 0 5.77625 0 6.72875V18.035C0 18.9912 0.77625 19.7675 1.7325 19.7675H22.2712C23.2275 19.7675 24.0037 18.9912 24 18.0387V6.72875C24 5.77625 23.2237 5 22.2675 5ZM12.6937 16.3062H10.3875V11.8062L8.08125 14.69L5.775 11.8062V16.3062H3.46125V8.46125H5.7675L8.07375 11.345L10.38 8.46125H12.6862V16.3062H12.6937ZM17.7675 16.4225L14.3062 12.3837H16.6125V8.46125H18.9187V12.3837H21.225L17.7675 16.4225Z',
            stroke: 'transparent',
            fill: 'currentColor',
        },
    ],
]);
/** @inheritdoc */
export const StepPromptEngineering = Object.freeze([
    outlineRect,
    ['path', { d: 'M6.83453 15.3666L9.86923 8.65356L12.9407 15.3666' }],
    ['line', { x1: 16.25, x2: 16.25, y1: 8.5, y2: 15.33 }],
    ['line', { y1: 13.63, y2: 13.63, x1: 7.646, x2: 12.1 }],
]);
/** @inheritdoc */
export const NodeJS = Object.freeze([
    [
        'path',
        {
            d: 'M8.55362 8.29096V16.725C8.55362 18.4897 6.64289 19.5923 5.11503 18.7092L3.84484 17.9751C3.13627 17.5656 2.69986 16.8093 2.69986 15.9909V8.17935C2.69986 7.38135 3.11495 6.64081 3.79567 6.22437L10.6671 2.02074C11.3835 1.58244 12.2823 1.57116 13.0095 1.99134L20.351 6.23304C21.0598 6.64252 21.4963 7.39891 21.4963 8.21742V15.9714C21.4963 16.8002 21.0488 17.5645 20.326 17.97L12.978 22.0931C12.2669 22.4921 11.3973 22.4832 10.6945 22.0698L10.0036 21.6634',
        },
    ],
    [
        'path',
        {
            d: 'M17.2835 9.9248C15.9978 7.63914 11.5621 7.73535 11.5621 10.1913C11.5621 12.6472 17.5903 11.3324 17.5903 13.8626C17.5903 16.3928 12.5406 16.325 11.3141 14.2102',
        },
    ],
]);
/** @inheritdoc */
export const Python = Object.freeze([
    [
        'path',
        {
            d: 'M22.115 9.39684C21.754 7.94835 21.0696 6.85612 19.6118 6.85612H17.732V9.07808C17.732 10.8031 16.2694 12.2563 14.6006 12.2563H9.59419C8.22539 12.2563 7.09097 13.4282 7.09097 14.8017V19.5738C7.09097 20.9332 8.27226 21.7301 9.59419 22.1192C11.1786 22.5833 12.7021 22.6677 14.6006 22.1192C15.8616 21.7536 17.1038 21.0176 17.1038 19.5738V17.6659H12.1021V17.0284H19.6118C21.0696 17.0284 21.6087 16.0112 22.115 14.4877C22.64 12.9173 22.6166 11.4079 22.115 9.39684ZM14.9147 18.9363C15.435 18.9363 15.8569 19.3628 15.8569 19.8879C15.8569 20.4176 15.435 20.8441 14.9147 20.8441C14.3991 20.8441 13.9725 20.4129 13.9725 19.8879C13.9772 19.3582 14.3991 18.9363 14.9147 18.9363ZM9.36449 11.6282H14.3709C15.7632 11.6282 16.8741 10.4797 16.8741 9.08277V4.30603C16.8741 2.9466 15.7304 1.92937 14.3709 1.69968C12.6927 1.4231 10.8692 1.43717 9.36449 1.70437C7.24566 2.07938 6.86127 2.86222 6.86127 4.31071V6.2186H11.8724V6.85612H4.98151C3.52365 6.85612 2.2486 7.73272 1.85015 9.39684C1.39075 11.3047 1.372 12.4954 1.85015 14.4877C2.20641 15.969 3.05488 17.0284 4.51275 17.0284H6.23312V14.7408C6.23312 13.086 7.66286 11.6282 9.36449 11.6282ZM9.05042 4.94355C8.53008 4.94355 8.10819 4.51697 8.10819 3.99195C8.11288 3.46224 8.53008 3.03567 9.05042 3.03567C9.56606 3.03567 9.99264 3.46693 9.99264 3.99195C9.99264 4.51697 9.57075 4.94355 9.05042 4.94355Z',
            stroke: 'transparent',
            fill: 'currentColor',
        },
    ],
]);
/** @inheritdoc */
export const StepQuiz = Object.freeze([
    outlineRect,
    ['path', { d: 'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3' }],
    ['path', { d: 'M12 17h.01' }],
]);
/** @inheritdoc */
export const PartialState = Object.freeze([
    outlineCircle,
    [
        'path',
        {
            d: 'M6.09805 12.0759C11.396 7.36715 13.3827 16.8354 17.8198 12.0759',
        },
    ],
]);
/** @inheritdoc */
export const AddNotebookCellAbove = Object.freeze([
    ['rect', { x: 3, y: 11, width: 18, height: 10, r: 1 }],
    ['line', { x1: 9, y1: 5, x2: 15, y2: 5 }],
    ['line', { x1: 12, y1: 2, x2: 12, y2: 8 }],
]);
/** @inheritdoc */
export const AddNotebookCellBelow = Object.freeze([
    ['rect', { x: 3, y: 2.5, width: 18, height: 10, r: 1 }],
    ['line', { x1: 9, y1: 19, x2: 15, y2: 19 }],
    ['line', { x1: 12, y1: 16, x2: 12, y2: 22 }],
]);
/** @inheritdoc */
export const MessageSquareMinus = Object.freeze([
    ['path', { d: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' }],
    ['path', { d: 'M9 10h6' }],
]);
